<template>
  <div class="page-wrapper">
      <ToolBar
        :handleToolSide="handleToolSide"
        :handleToolHeadBtn="handleToolHeadBtn"
        :title="title"
        :toolbarIcon="toolbarIcon"
        :toolbarColor="toolbarColor"
      >
      <v-spacer></v-spacer>
      </ToolBar>

      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 md6>
           <div class="lost">404</div>
          </v-flex>
        </v-layout>
      </v-container>
  </div>
</template>
<script>
import ToolBar from '@/components/ToolBar'
export default {
  components: {
    ToolBar,
  },
  data: () => ({
    toolbarColor: 'red darken-2',
    toolbarIcon: 'home',
    title: 'Page inexistante',
  }),
  methods: {
    handleToolSide () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch('ui/toggleDrawer', payload)
    },
    handleToolHeadBtn () {
      this.$router.push({path: '/'})
    },
  },
}
</script>

<style scoped>
  .lost {
    font-size: 10em;
    text-align: center;
  }
  .page-wrapper {
    height: 100%;
    width: 100%;
  }
</style>
